























import { defineComponent, reactive } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import useDownloadReport from '@/useDownloadReport';

const NOW = useFormat.date().computerShortDate();

const DriverIncomeCsvReport = defineComponent({
  setup() {
    const { getCSVReport } = useDownloadReport();
    const filter = reactive({
      type: 'fee',
      range: {
        from: undefined,
        to: undefined,
      },
    });

    return {
      filter,
      getCSVReport,
    };
  },
});

export default DriverIncomeCsvReport;
